module.exports = __webpack_public_path__ + "img/task.c876af6f.svg";